import * as React from 'react';
import styled from 'styled-components';
import MuiCardMedia, { CardMediaProps as MuiCardMediaProps } from '@material-ui/core/CardMedia';

const StyledCardMedia = styled(MuiCardMedia)``;

export type DSCardMediaProps<C extends React.ElementType> = MuiCardMediaProps<C, { component?: C }>;

export function DSCardMedia<C extends React.ElementType>(props: DSCardMediaProps<C>): JSX.Element {
    return <StyledCardMedia {...props} />;
}
DSCardMedia.displayName = 'DSCardMedia';
